/** Resets window/document scroll and common in-app scroll containers (e.g. dashboard main column). */
export function resetScrollPosition(): void {
  globalThis.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  document
    .querySelectorAll<HTMLElement>(".main-content, .mobile-content, .mobile-container")
    .forEach((el) => {
      el.scrollTop = 0;
    });
}
